/** @type {import('../schema').ExperienceEntity[]} */
export const sxswSydneyEntities = [
  {
    id: 'sxsw-sydney',
    slug: 'sxsw-sydney',
    entityType: 'venue',
    name: 'SXSW Sydney',
    shortDescription: 'A gathering of innovators, entrepreneurs, creators, and technologists from around the world.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'tumbalong-park',
    slug: 'tumbalong-park',
    entityType: 'venue',
    name: 'Tumbalong Park',
    shortDescription: 'The outdoor heart of the conference, with live concerts every afternoon.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'teddy-swims-keynote',
    slug: 'teddy-swims-keynote',
    entityType: 'session',
    name: 'Teddy Swims Keynote',
    shortDescription: 'A memorable keynote that connected creativity, resilience, and the work behind the performance.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'mo-gawdat-human-advantage-keynote',
    slug: 'mo-gawdat-human-advantage-keynote',
    entityType: 'session',
    name: 'The Human Advantage: Why AI Makes Us More, Not Less',
    shortDescription: 'A keynote by Mo Gawdat about the human qualities that matter most in an AI-shaped future.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'niall-firth-ai-in-2026',
    slug: 'niall-firth-ai-in-2026',
    entityType: 'session',
    name: 'AI in 2026',
    shortDescription: 'A session by Niall Firth exploring the near-term direction of artificial intelligence and what comes next.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'w-sydney',
    slug: 'w-sydney',
    entityType: 'hotel',
    name: 'W Sydney',
    shortDescription: 'The crew’s Darling Harbour home base for the week.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    websiteUrl: 'https://www.marriott.com/en-us/hotels/sydwh-w-sydney/overview/',
  },
  {
    id: 'coogee-bondi-walk',
    slug: 'coogee-to-bondi-coastal-walk',
    entityType: 'activity',
    name: 'Coogee to Bondi Coastal Walk',
    shortDescription: 'Cliffs, beaches, Pacific views, and Sculpture by the Sea along one of the world’s great coastal walks.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'manly-ferry',
    slug: 'ferry-to-manly',
    entityType: 'activity',
    name: 'Ferry to Manly Beach',
    shortDescription: 'An iconic ride across Sydney Harbour followed by an afternoon in Manly.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'exploring-the-rocks',
    slug: 'exploring-the-rocks',
    entityType: 'activity',
    name: 'Exploring The Rocks',
    shortDescription: 'A first-night pub discovery, a Day 2 pub crawl, and another stop after the Manly ferry outing.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'manly-beach',
    slug: 'manly-beach',
    entityType: 'place',
    name: 'Manly Beach',
    shortDescription: 'A harbor ferry ride away from central Sydney, with ocean air, beach time, fish and chips, and local beer.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'bondi-beach',
    slug: 'bondi-beach',
    entityType: 'place',
    name: 'Bondi Beach',
    shortDescription: 'The iconic finish to our first-day coastal walk from Coogee.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'blue-mountains',
    slug: 'blue-mountains',
    entityType: 'place',
    name: 'Blue Mountains',
    shortDescription: 'Rainforest, the Three Sisters, and sweeping views across Jamison Valley.',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'scenic-world',
    slug: 'scenic-world',
    entityType: 'activity',
    name: 'Scenic World',
    shortDescription: 'The Scenic Railway, Skyway, and rainforest boardwalks gave the crew a different view of Australia.',
    region: 'New South Wales',
    country: 'Australia',
    websiteUrl: 'https://www.scenicworld.com.au/',
  },
  {
    id: 'featherdale-sydney-wildlife-park',
    slug: 'featherdale-sydney-wildlife-park',
    entityType: 'activity',
    name: 'Featherdale Sydney Wildlife Park',
    shortDescription: 'An up-close introduction to koalas, kangaroos, and other Australian wildlife on the way to the Blue Mountains.',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'the-rocks',
    slug: 'the-rocks',
    entityType: 'place',
    name: 'The Rocks',
    shortDescription: 'Historic lanes, harbor views, and pub stops explored after dinner.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'sydney-harbour',
    slug: 'sydney-harbour',
    entityType: 'place',
    name: 'Sydney Harbour',
    shortDescription: 'The Opera House, Harbour Bridge, ferries, and sunsets that framed the week.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'bondi-trattoria',
    slug: 'bondi-trattoria',
    entityType: 'restaurant',
    name: 'Bondi Trattoria',
    shortDescription: 'Beachfront Italian just steps from Bondi Beach.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'quay-sydney',
    slug: 'quay-sydney',
    entityType: 'restaurant',
    name: 'Quay',
    shortDescription: 'Fine dining overlooking the Opera House, Harbour Bridge, and Sydney Harbour.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    websiteUrl: 'https://www.quay.com.au/',
  },
  {
    id: 'glenmore-hotel',
    slug: 'glenmore-hotel',
    entityType: 'restaurant',
    name: 'Glenmore Hotel',
    shortDescription: 'A historic rooftop pub overlooking Sydney Harbour.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'fortune-of-war',
    slug: 'fortune-of-war-hotel',
    entityType: 'restaurant',
    name: 'Fortune of War Hotel',
    shortDescription: 'Australia’s oldest continually licensed pub.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'australian-heritage-hotel',
    slug: 'australian-heritage-hotel',
    entityType: 'restaurant',
    name: 'Australian Heritage Hotel',
    shortDescription: 'A historic pub known for its Coat of Arms Pizza.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'harts-pub',
    slug: 'harts-pub',
    entityType: 'restaurant',
    name: 'Hart’s Pub',
    shortDescription: 'A pub stop during the Day 2 crawl through and around The Rocks.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'nine-dragons',
    slug: 'nine-dragons',
    entityType: 'restaurant',
    name: 'Nine Dragons',
    shortDescription: 'Traditional Cantonese dim sum in Sydney’s Chinatown.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'marrickville-hotel',
    slug: 'marrickville-hotel',
    entityType: 'restaurant',
    name: 'Marrickville Hotel',
    shortDescription: 'A casual neighborhood stop before the walk to dinner.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: '20-chapel',
    slug: '20-chapel',
    entityType: 'restaurant',
    name: '20 Chapel',
    shortDescription: 'A hidden dining destination and the unanimous group favorite.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: '4-pines-manly',
    slug: '4-pines-manly',
    entityType: 'restaurant',
    name: '4 Pines Brew Pub, Manly',
    shortDescription: 'The original 4 Pines brew pub and a well-earned ferry-day lunch.',
    city: 'Manly',
    region: 'New South Wales',
    country: 'Australia',
    websiteUrl: 'https://4pinesbeer.com.au/',
  },
  {
    id: 'mountain-culture',
    slug: 'mountain-culture-beer-co',
    entityType: 'restaurant',
    name: 'Mountain Culture Beer Co.',
    shortDescription: 'An award-winning brewery stop on the drive back from the Blue Mountains.',
    region: 'New South Wales',
    country: 'Australia',
    websiteUrl: 'https://mountainculture.com.au/',
  },
  {
    id: 'bar-torino',
    slug: 'bar-torino',
    entityType: 'restaurant',
    name: 'Bar Torino',
    shortDescription: 'A pre-dinner cocktail reset after the Blue Mountains.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'margaret-sydney',
    slug: 'margaret-sydney',
    entityType: 'restaurant',
    name: 'Margaret',
    shortDescription: 'An acclaimed Sydney steakhouse built around exceptional food and hospitality.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    websiteUrl: 'https://margaretdoublebay.com/',
  },
  {
    id: 'sydney-pub-crawl',
    slug: 'sydney-pub-crawl',
    entityType: 'restaurant',
    name: 'Sydney Pub Crawl',
    shortDescription: 'Historic pubs, rooftop bars, harbor-side pints, and neighborhood favorites discovered throughout the week.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
];

export const sxswSydneyEntityById = sxswSydneyEntities.reduce((entities, entity) => ({
  ...entities,
  [entity.id]: entity,
}), {});
